import { isEmpty } from '@imcc/utilities';
import { AppActions } from 'app/app-actions.enum';
import { AppAction } from '@app/actions/app-action';
import { SearchAction } from './actions/search-action';
import { SearchActions } from './actions/search-actions';
import { SearchResult } from './search-result';
import { initialState, SearchState } from './search-state';
import { TabAction } from './tab-action';

export function searchReducer(
  state: SearchState = initialState,
  action: SearchAction | TabAction | AppAction,
): SearchState {
  const newState = state || { ...initialState };

  switch (action.type) {
    case AppActions.LOAD_STATE_SUCCESS: {
      const { clientStateRequestDTO } = action;
      const { search } = clientStateRequestDTO;

      if (!search) return newState;

      return {
        ...newState,
        lastUpdated: search.lastUpdated,
      };
    }
    case SearchActions.SET_QUERY_STRING: {
      return {
        ...newState,
        queryString: action.queryString,
      };
    }
    case SearchActions.SET_SORT_ORDER: {
      return {
        ...newState,
        tabs: {
          ...newState.tabs,
          [action.indexName]: {
            ...newState.tabs[action.indexName],
            order: action.order,
            sortTerm: action.sortTerm,
            searchResult: new SearchResult(),
          },
        },
      };
    }
    case SearchActions.SEARCH: {
      return {
        ...newState,
        isUpdating: true,
        lastUpdated: new Date().getTime(),
        queryString: action.params.query,
        indexName: action.params.indexName,
        tabs: {
          ...newState.tabs,
          [action.params.indexName]: {
            ...newState.tabs[action.params.indexName],
            order: action.params.order,
            sortTerm: action.params.sortTerm,
            resultInteracted: false,
          },
        },
      };
    }
    case SearchActions.RESULT_FIRST_INTERACTION:
      return {
        ...newState,
        tabs: {
          ...newState.tabs,
          [newState.indexName]: {
            ...newState.tabs[newState.indexName],
            resultInteracted: true,
          },
        },
      };
    case SearchActions.SEARCH_SUCCESS: {
      const { indexName } = action.searchParams;

      return {
        ...newState,
        isUpdating: false,
        tabs: {
          ...newState.tabs,
          [indexName]: {
            ...newState.tabs[indexName],
            searchResult: action.searchResult,
            foundAssets: action.searchResult.info.totalHits,
          },
        },
      };
    }
    case SearchActions.NEXT_BATCH: {
      return {
        ...newState,
        isUpdating: true,
      };
    }
    case SearchActions.NEXT_BATCH_SUCCESS: {
      const { searchResult } = action;

      if (isEmpty(searchResult.hits)) {
        return { ...newState, isUpdating: false };
      }

      const { indexName } = action.searchParams;
      const tabState = newState.tabs[indexName];
      const { hits, info } = tabState.searchResult;
      const newSearchResult: SearchResult = {
        hits: [...hits, ...searchResult.hits],
        info: {
          ...info,
          nextPage: searchResult.info.nextPage,
        },
      };

      return {
        ...newState,
        isUpdating: false,
        tabs: {
          ...newState.tabs,
          [indexName]: {
            ...tabState,
            searchResult: newSearchResult,
          },
        },
      };
    }
    case SearchActions.SEARCH_ERROR: {
      return { ...newState, isUpdating: false };
    }
    case SearchActions.SET_THUMBNAIL_SIZE:
      return {
        ...newState,
        thumbnailSize: action.thumbnailSize,
        tabs: {
          ...newState.tabs,
          [newState.indexName]: {
            ...newState.tabs[newState.indexName],
            thumbnailSize: action.thumbnailSize,
          },
        },
      };
    default:
      return newState;
  }
}
